import React, { useEffect, useState } from "react";
import { Col, Row, Spinner, Table } from "reactstrap";
import { CubeBasicFilters, CubeSummaryResponse } from "../schemas/kpi.types";
import { ReactComponent as IconMale } from "../../../assets/img/icon/dashboard/siniestralidad.svg";
import { ReactComponent as IconFemale } from "../../../assets/img/icon/dashboard/proveedor_ambulatorio.svg";
import { kpiService } from "./kpi-service";
import { formatCurrency } from "../schemas/dashboard.utils";

export const KPIGenderTable: React.FC<{
    cubeFilters: CubeBasicFilters;
    gender: string;
    title: string;
}> = ({ cubeFilters, gender, title }) => {
    const [cubeSummary, setCubeSummary] = useState<CubeSummaryResponse[]>([]);
    const [loading, setLoading] = useState(false);
    const { idClient, idQuotes, policy } = cubeFilters;

    useEffect(() => {
        const loadData = async () => {
            if (!idClient) return;
            try {
                setLoading(true);
                const cubeGenderData = await kpiService.fetchGenderSummary(cubeFilters, gender);
                setCubeSummary(cubeGenderData);
            } catch (error) {
                console.error("Error al cargar tabla:", error);
            } finally {
                setLoading(false);
            }
        };

        void loadData();
    }, [idClient, idQuotes, policy, gender]);

    const totalCount = cubeSummary.reduce((accum, cube) => accum + (cube.amount || 0), 0);
    const totalPaid = cubeSummary.reduce((accum, cube) => accum + (cube.total || 0), 0);

    return (
        <div className="siniestralidad-container">
            <div className="header-section">
                <div className="icon-wrapper">{"F" === gender ? <IconFemale /> : <IconMale />}</div>
                <h2 className="title-label">{title}</h2>
            </div>
            <Row>
                <Col>
                    {loading ? (
                        <div className="text-center py-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <div className="table-responsive-wrapper" style={{ height: "330px", overflowY: "auto" }}>
                            <Table hover responsive className="align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-left">Diagnóstico</th>
                                        <th className="text-center">No. Casos</th>
                                        <th className="text-right">Total pagado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cubeSummary.length > 0 ? (
                                        cubeSummary.map((cube, index) => (
                                            <tr key={index + cube.type}>
                                                <td className="text-left">{cube.type}</td>
                                                <td className="text-center">{cube.total}</td>
                                                <td className="text-right">{formatCurrency(cube.amount)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="text-center text-muted">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {cubeSummary.length > 0 && (
                                    <tfoot className="table-group-divider">
                                        <tr className="font-weight-bold" style={{ fontWeight: "bold" }}>
                                            <td className="text-left">Total</td>
                                            <td className="text-center">{totalPaid}</td>
                                            <td className="text-right">{formatCurrency(totalCount)}</td>
                                        </tr>
                                    </tfoot>
                                )}
                            </Table>
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
};
